import type { FunctionComponent } from "react";

import {
  Container,
  StyledButton,
  StyledErrorPeter,
  StyledPeter,
  TextWrapper,
  ThankYouMessage,
  Title,
} from "./styles";

export type MessageBoxVariant = "expired" | "invalid" | "thank-you";
type Props = {
  className?: string;
  onCloseDrawer: () => void;
  variant: MessageBoxVariant;
};
export const PostiesStudentFormMessageBox: FunctionComponent<Props> = ({
  className,
  onCloseDrawer,
  variant,
}) => {
  const getMessages = () => {
    switch (variant) {
      case "expired":
        return {
          button: "BACK",
          description: "This form is no longer accepting submissions.",
          image: <StyledErrorPeter />,
          title: "Sorry, something went wrong. ",
        };
      case "invalid":
        return {
          button: "BACK",
          description: "Please contact us at editorial@posties.hk if you have questions.",
          image: <StyledErrorPeter />,
          title: "Sorry, something went wrong. ",
        };
      default:
        return {
          button: "DONE",
          description:
            "Keep an eye on our website and newspaper to see if your work is published. We look forward to seeing you write for us again!",
          image: <StyledPeter />,
          title: "Thank you for your submission!",
        };
    }
  };

  const messages = getMessages();

  return (
    <Container className={className}>
      {messages.image}
      <TextWrapper>
        <Title>{messages.title}</Title>
        <ThankYouMessage>{messages.description}</ThankYouMessage>
      </TextWrapper>
      <StyledButton onClick={onCloseDrawer} variant="button">
        {messages.button}
      </StyledButton>
    </Container>
  );
};

PostiesStudentFormMessageBox.displayName = "PostiesStudentFormMessageBox";
